"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "abbadia-cerreto": {
    "61b57f8e": [{
      "hkey": "1fc6d877",
      "slug": "abbadia-cerreto",
      "name": "Abbadia Cerreto",
      "primary": true,
      "skipSearch": false
    }],
    "cantarana": [{
      "hkey": "1fc6d877",
      "slug": "abbadia-cerreto",
      "name": "Abbadia Cerreto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a4f6aa53": [{
      "hkey": "1fc6d877",
      "slug": "abbadia-cerreto",
      "name": "Abbadia Cerreto",
      "primary": true,
      "skipSearch": false
    }],
    "isella-san-cipriano": [{
      "hkey": "1fc6d877",
      "slug": "abbadia-cerreto",
      "name": "Abbadia Cerreto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2cf64a36": [{
      "hkey": "1fc6d877",
      "slug": "abbadia-cerreto",
      "name": "Abbadia Cerreto",
      "primary": true,
      "skipSearch": false
    }],
    "mirabellino": [{
      "hkey": "1fc6d877",
      "slug": "abbadia-cerreto",
      "name": "Abbadia Cerreto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1c2a5aae": [{
      "hkey": "1fc6d877",
      "slug": "abbadia-cerreto",
      "name": "Abbadia Cerreto",
      "primary": true,
      "skipSearch": false
    }],
    "padule": [{
      "hkey": "1fc6d877",
      "slug": "abbadia-cerreto",
      "name": "Abbadia Cerreto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;